import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AdminDashboardTabTypes from "../redux/actions/types/AdminDashboardTabTypes";
import ButtonTabs from "../../../../core/modules/common/components/ButtonTabs";
import { getAdminDashboardTab } from "../redux/selectors/AdminDashboardSelectors";
import { selectAdminTabActionCreator } from "../redux/actions/AdminDashboardActions";
import AdminReportCategoriesContainer from "./AdminReportCategoriesContainer";
import AdminGenericContainer from "./AdminGenericContainer";
import AdminGlobalPresetContainer from "./AdminGlobalPresetContainer";
import { pushHistory } from "../../../../core/modules/common/tools/HistoryTools";
import { constructPath } from "../../../../core/modules/common/tools/URLTools";
import {
  getIsAdmin,
  getUserLoaded,
} from "../../../user/redux/selectors/UserReportSelectors";
import { fetchUserReportDefinitionsRequestActionCreator } from "../../../user/redux/actions/UserActions";
import { httpOnlySecurityService } from "../../../../externals/iam";

export const tabs = [
  {
    value: AdminDashboardTabTypes.GENERIC,
    label: "GENERIC",
  },
  {
    value: AdminDashboardTabTypes.GLOBAL_PRESETS,
    label: "GLOBAL PRESETS",
  },
  {
    value: AdminDashboardTabTypes.REPORT_CATEGORIES,
    label: "REPORT CATEGORIES",
  },
];

export const defaultTab = "GENERIC";

export class AdminDashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "GENERIC",
    };
  }

  componentDidMount() {
    // Only fetch user data if not already loaded
    if (!this.props.userLoaded) {
      this.props.fetchUserReportDefinitionsRequestActionCreator();
    }
    this.props.selectAdminTabActionCreator(this.state.activeTab);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAdmin !== prevProps.isAdmin && !this.props.isAdmin) {
      pushHistory(constructPath(`${this.props.language}/login`));
    }
  }

  navigateTab = (activeTab) => {
    if (!httpOnlySecurityService.isUserAuthenticated()) {
      pushHistory(constructPath(`${this.props.language}/login`));
    }
    this.setState({
      activeTab,
    });
  };

  isGenericActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.GENERIC;

  isGlobalPresetsActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.GLOBAL_PRESETS;

  isReportCategoriesActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.REPORT_CATEGORIES;

  render() {
    const { activeTab } = this.state;

    return (
      <div className="admin-dashboard">
        <div className="dashboard-tabs">
          <ButtonTabs
            tabs={tabs}
            activeTab={activeTab}
            onChange={this.navigateTab}
            dashboard
          />
        </div>
        {this.isGenericActive() && <AdminGenericContainer />}
        {this.isGlobalPresetsActive() && <AdminGlobalPresetContainer />}
        {this.isReportCategoriesActive() && <AdminReportCategoriesContainer />}
      </div>
    );
  }
}

AdminDashboardContainer.propTypes = {
  selectAdminTabActionCreator: PropTypes.func,
  language: PropTypes.string,
  isAdmin: PropTypes.bool,
  userLoaded: PropTypes.bool,
  fetchUserReportDefinitionsRequestActionCreator: PropTypes.func,
};

const mapStateToProps = (state) => ({
  activeTab: getAdminDashboardTab(state),
  language: state.global.locales.lang,
  isAdmin: getIsAdmin(state),
  userLoaded: getUserLoaded(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectAdminTabActionCreator,
      fetchUserReportDefinitionsRequestActionCreator,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminDashboardContainer);
